// components/configuration/tabs/GenericSettingsTab.jsx
import React from 'react';
import SettingsSection from './SettingsSection';
import SettingsField from './SettingsField';

/**
 * Generic settings tab component
 * Can render any category of settings based on configuration
 * 
 * @param {object} categoryConfig - Configuration from SETTINGS_CONFIG
 * @param {object} configs - Current configuration values
 * @param {function} updateConfig - Function to update a config value
 * @param {string} saveStatus - Current save status
 * @param {function} onSave - Save handler
 * @param {function} onReset - Reset handler
 */
const GenericSettingsTab = ({ 
  categoryConfig,
  configs, 
  updateConfig, 
  saveStatus, 
  onSave, 
  onReset 
}) => {
  if (!categoryConfig) {
    return (
      <div className="text-center py-8 text-gray-500">
        Settings category not found
      </div>
    );
  }

  return (
    <SettingsSection
      title={categoryConfig.title}
      description={categoryConfig.description}
      onSave={onSave}
      onReset={onReset}
      saveStatus={saveStatus}
    >
      <div className="space-y-4">
        {categoryConfig.fields.map((field) => (
          <SettingsField
            key={field.key}
            field={field}
            value={configs[field.key]}
            onChange={updateConfig}
            configs={configs}
          />
        ))}
      </div>
    </SettingsSection>
  );
};

export default GenericSettingsTab;